import {
	Checkbox,
	Group,
	Radio,
	createStyles,
	getStylesRef,
} from '@mantine/core';
import { ListBox } from '@repo/foundations';
import type { EditItem } from '../../types';
import { EditValueType } from '../../types';

const useStyles = createStyles(
	(theme, { selected }: { selected: boolean }) => ({
		menuItem: {
			[`&[data-hovered] .${getStylesRef('checkbox')}`]: {
				visibility: 'visible',
			},
			padding: theme.spacing['xs'],
			margin: `0 ${theme.spacing['2xs']}`,
			width: `calc(100% - (2 * ${theme.spacing['2xs']}))`,
		},
		checkbox: {
			ref: getStylesRef('checkbox'),

			visibility: selected ? 'visible' : 'hidden',
		},
	})
);

interface EditActionValueItemProps {
	editValueType: EditValueType;
	item: EditItem;
	onClick: (close: boolean) => void;
	selected?: boolean;
	getProps: (
		userProps: Omit<React.HTMLProps<HTMLElement>, 'ref'>
	) => Omit<React.HTMLProps<HTMLElement>, 'ref'>;
}

export function EditActionValueItem({
	editValueType,
	item,
	onClick,
	selected = false,
	getProps,
}: EditActionValueItemProps) {
	const { classes } = useStyles({ selected });

	return (
		<ListBox.Item
			{...getProps({
				onClick: () => onClick(true),
				className: classes.menuItem,
			})}
		>
			<Group
				noWrap
				data-testid={`edit-action-value-item-${item.value}`}
				spacing="2xs"
			>
				{editValueType === EditValueType.MULTIPLE && (
					<Checkbox
						checked={selected}
						onClick={(event) => event.stopPropagation()}
						onChange={() => onClick(true)}
						className={classes.checkbox}
					/>
				)}
				{editValueType === EditValueType.SINGLE && (
					<Radio
						checked={selected}
						onClick={(event) => event.stopPropagation()}
						onChange={() => onClick(true)}
						className={classes.checkbox}
					/>
				)}
				{item.icon}
				{item.label}
			</Group>
		</ListBox.Item>
	);
}
